import request from '@/tools/request'
import { HTTP } from './http'
import { TableRes } from '@/global'
import { getSupplierId, getUserId } from '@/tools'
import { omit } from 'lodash'
const { GET, POST } = request

export interface InquiryOrderQueryDTO {
  /**
   * 完结状态：1-未完结，2-已完结，3-全部
   */
  completionStatus?: number
  /**
   * 询价截止日期-结束
   */
  endExpireDate?: number
  /**
   * 询价公司名称
   */
  groupName?: string
  /**
   * 询价单号
   */
  inquiryNo?: string
  /**
   * 是否已到期
   */
  isExpired?: boolean
  /**
   * 是否即将到期（3天内）
   */
  isExpiringSoon?: boolean
  /**
   * 是否急单
   */
  isUrgent?: boolean
  /**
   * 物料条数
   */
  materialCount?: number
  /**
   * 物料条数操作符
   * 0 :EQUALS
   * 1 :LESS
   * 2 :GREATER
   * 3 :NO_EQUALS
   */
  materialCountOperator?: MaterialCountOperator
  /**
   * 当前页
   */
  pageNo?: number
  /**
   * 每页展示数量
   */
  pageSize?: number
  /**
   * 采购员姓名
   */
  purchaserName?: string
  /**
   * 搜索方案ID
   */
  schemeId?: string
  /**
   * 询价截止日期-开始
   */
  startExpireDate?: number
  /**
   * 状态（供应商响应状态）
   * 0 :待接单：供应商在SCP接单
   * 1 :待报价：供应商在SCP对待接单的询价单直接报价
   * 2 :已报价：供应商在SCP对待报价的询价单进行报价
   * 3 :待重新报价：采购在SRM重新报价，供应商在SCP重新报价
   * 4 :采购方取消：采购在SRM放弃询价或采购在SRM选用了其他报价
   */
  status?: Status
  /**
   * 供应商ID
   */
  supplierId: string
  /**
   * 用户ID
   */
  userId: string
  [property: string]: any
}

/**
 * 物料条数操作符
 * 0 :EQUALS
 * 1 :LESS
 * 2 :GREATER
 * 3 :NO_EQUALS
 */
export enum MaterialCountOperator {
  The0 = '0',
  The1 = '1',
  The2 = '2',
  The3 = '3',
}

/**
 * 状态（供应商响应状态）
 * 0 :待接单：供应商在SCP接单
 * 1 :待报价：供应商在SCP对待接单的询价单直接报价
 * 2 :已报价：供应商在SCP对待报价的询价单进行报价
 * 3 :待重新报价：采购在SRM重新报价，供应商在SCP重新报价
 * 4 :采购方取消：采购在SRM放弃询价或采购在SRM选用了其他报价
 */
export enum Status {
  The0 = '0',
  The1 = '1',
  The2 = '2',
  The3 = '3',
  The4 = '4',
}

export interface InquiryOrderDTO {
  /**
   * 创建时间
   */
  createdAt?: number
  /**
   * 询价截止日期
   */
  expireDate?: number
  /**
   * 询价公司名称
   */
  groupName?: string
  /**
   * 询价单ID
   */
  inquiryId?: string
  /**
   * 询价单号
   */
  inquiryNo?: string
  /**
   * 物料条数
   */
  materialCount?: number
  /**
   * 采购员姓名
   */
  purchaserName?: string
  /**
   * 供应商响应状态
   */
  status?: string
  /**
   * 供应商响应状态文案
   */
  statusText?: string
  /**
   * 标签列表
   */
  tags?: string[]
  /**
   * 是否急单：0-否 1-是
   */
  urgent?: 0 | 1
}

export interface InquiryOrderItemDTO {
  /**
   * 询价单创建时间戳
   */
  createdAt?: number
  /**
   * 询价截止日期时间戳
   */
  expireDate?: number
  /**
   * 询价公司名称
   */
  groupName?: string
  /**
   * 询价单ID
   */
  inquiryId?: string
  /**
   * 询价明细ID（行ID）
   */
  inquiryItemId?: string
  /**
   * 询价单号
   */
  inquiryNo?: string
  /**
   * 物料条数（询价单包含的物料项数）
   */
  materialCount?: number
  /**
   * 采购员姓名
   */
  purchaserName?: string
  /**
   * 供应商响应状态（编码）
   */
  status?: string
  /**
   * 供应商响应状态文案
   */
  statusText?: string
  /**
   * 标签列表（如 急单 等）
   */
  tags?: string[]
  /**
   * 是否急单：0-否 1-是
   */
  urgent?: 0 | 1
  /**
   * 附件路径（多个用逗号分隔）
   */
  attachment?: string
  /**
   * 前端分组标记：同一询价单号首行标识
   */
  __isFirstOfInquiry?: boolean
  /**
   * 序号（行排序号）
   */
  sortOrder?: number
  /**
   * 明细状态（编码）
   */
  itemStatus?: string
  /**
   * 明细状态文案
   */
  itemStatusText?: string
  /**
   * 来源唯一标识码
   */
  inquiryTaskNo?: string
  /**
   * 客方物料名称
   */
  clientMaterialName?: string
  /**
   * 客方需求数量
   */
  clientMaterialQty?: number
}

// 供应商询价单列表分页查询
export const GET_INQUIRY_LIST = (params: InquiryOrderQueryDTO) =>
  GET<TableRes<InquiryOrderDTO>>(`${HTTP}/inquiry/list`, {
    ...params,
    supplierId: getSupplierId(),
  })

export const GET_INQUIRY_LIST_ITEMS = (params: InquiryOrderQueryDTO) =>
  GET<TableRes<InquiryOrderItemDTO>>(`${HTTP}/inquiry/list/items`, {
    ...params,
    supplierId: getSupplierId(),
  })

/**
 * 结果数据
 *
 * InquiryTabCountVO
 */
export interface InquiryTabCountVO {
  /**
   * 已完结数量
   */
  finishedCount: number
  /**
   * 全部数量
   */
  totalCount: number
  /**
   * 未完结数量
   */
  unfinishedCount: number
}
// 供应商询价单TAB数量统计
export const GET_INQUIRY_TABCOUNTS = (params: InquiryOrderQueryDTO) =>
  GET<InquiryTabCountVO>(`${HTTP}/inquiry/tabCounts`, {
    ...params,
    supplierId: getSupplierId(),
  })

export interface SupplierInquiryWithQuotationVO {
  /**
   * 接单时间戳
   */
  acceptTime?: number
  /**
   * 四级类目编码
   */
  categoryLevel4Code?: string
  /**
   * 四级类目名称
   */
  categoryLevel4Name?: string
  /**
   * 邮箱
   */
  contactEmail?: string
  /**
   * 供应商联系人
   */
  contactPerson?: string
  /**
   * 联系电话
   */
  contactPhone?: string
  /**
   * 采购部门编码
   */
  departmentCode?: string
  /**
   * 采购部门名称
   */
  departmentName?: string
  /**
   * 询价截止日期时间戳
   */
  expireDate?: number
  /**
   * 组织编码
   */
  groupCode?: string
  /**
   * 是否已报价
   */
  hasQuoted?: boolean
  /**
   * 询价单附件路径
   */
  inquiryAttachment?: string
  /**
   * 询价单创建时间戳
   */
  inquiryCreatedAt?: number
  /**
   * 询价单创建人姓名
   */
  inquiryCreatorName?: string
  /**
   * 询价单ID
   */
  inquiryId?: string
  /**
   * 询价单号
   */
  inquiryNo?: string
  /**
   * 供应商响应状态（来自InquiryAllowedSupplier表）
   * 供应商响应状态
   */
  inquiryStatus?: InquiryStatus
  /**
   * 供应商响应状态文案
   */
  inquiryStatusText?: string
  /**
   * 询价单标签列表
   */
  inquiryTags?: string[]
  /**
   * 询价类型
   */
  inquiryType?: InquiryType
  /**
   * 询价类型文案
   */
  inquiryTypeText?: string
  /**
   * 报价明细列表（包含询价单明细信息和对应的报价信息）
   * 对于未报价的明细，只包含询价信息，报价相关字段为空
   * 报价明细列表（包含询价单明细和报价信息）
   */
  items: QuotationItemDTO[]
  /**
   * 上次催办时间时间戳
   */
  lastReminderTime?: number
  /**
   * 采购员工号编码
   */
  purchaserCode?: string
  /**
   * 采购员姓名
   */
  purchaserName?: string
  /**
   * 报价单附件路径
   */
  quotationAttachment?: string
  /**
   * 报价单创建时间戳
   */
  quotationCreatedAt?: number
  /**
   * 报价单创建人姓名
   */
  quotationCreatorName?: string
  /**
   * 报价单ID
   */
  quotationId?: string
  /**
   * 报价单号
   */
  quotationNo?: string
  /**
   * 报价单标签列表
   */
  quotationTags?: string[]
  /**
   * 驳回原因
   */
  rejectReason?: string
  /**
   * 备注说明
   */
  remark?: string
  /**
   * 提交时间戳
   */
  submitTime?: number
  /**
   * 供应商地址
   */
  supplierAddress?: string
  /**
   * 供应商ID
   */
  supplierId?: string
  /**
   * 供应商名称
   */
  supplierName?: string
  /**
   * 合计金额
   */
  totalAmount?: number
  /**
   * 是否急单：0-否 1-是
   */
  urgent?: number
  /**
   * 报价有效期时间戳
   */
  validUntil?: number
  lastTempSaveTime?: number
}

/**
 * 供应商响应状态（来自InquiryAllowedSupplier表）
 * 供应商响应状态
 */
export enum InquiryStatus {
  The0 = '0',
  The1 = '1',
  The2 = '2',
  The3 = '3',
  The4 = '4',
}

/**
 * 询价类型
 */
export enum InquiryType {
  The0 = '0',
  The1 = '1',
}

/**
 * 报价单明细DTO
 *
 * QuotationItemDTO
 */
export interface QuotationItemDTO {
  /**
   * 金额
   */
  amount?: number
  /**
   * 产品明细附件路径（多个用逗号分隔）
   */
  attachment?: string
  /**
   * 客方物资品牌（冗余）
   */
  clientMaterialBrand?: string
  /**
   * 客方物资描述（冗余）
   */
  clientMaterialDesc?: string
  /**
   * 客方物资名称（冗余）
   */
  clientMaterialName?: string
  /**
   * 客方需求数量（冗余）
   */
  clientMaterialQty?: number
  /**
   * 客方物资规格（冗余）
   */
  clientMaterialSpec?: string
  /**
   * 客方物资单位（冗余）
   */
  clientMaterialUnit?: string
  /**
   * 客方备注
   */
  clientRemark?: string
  /**
   * 配置明细
   */
  configDetail?: string
  /**
   * 创建时间戳
   */
  createdAt?: number
  /**
   * 交货地点（冗余）
   */
  deliveryAddress?: string
  /**
   * 货期（枚举的中文描述）
   */
  deliveryPeriod?: string
  /**
   * 主键
   */
  id?: string
  /**
   * 是否含运费：0-否 1-是
   */
  includeFreight?: number
  /**
   * 对应的询价明细ID
   */
  inquiryItemId?: string
  /**
   * 询价任务编号（冗余）
   */
  inquiryTaskNo?: string
  /**
   * 报价明细状态：DRAFT-暂存，QUOTED-已报价
   */
  itemStatus?: string
  /**
   * 产品市场价
   */
  marketPrice?: number
  /**
   * 参数差异点
   */
  paramDifference?: string
  /**
   * 产品限价（单价）
   */
  priceLimit?: number
  /**
   * 报价单ID
   */
  quotationId?: string
  /**
   * 报价要求（冗余）
   */
  quotationRequirement?: string
  /**
   * 报价品牌
   */
  quoteProductBrand?: string
  /**
   * 报价产品编码
   */
  quoteProductCode?: string
  /**
   * 报价产品名称
   */
  quoteProductName?: string
  /**
   * 报价产品规格型号
   */
  quoteProductSpec?: string
  /**
   * 报价数量
   */
  quoteQty?: number
  /**
   * 报价单位
   */
  quoteUnit?: string
  /**
   * 报价单位编码
   */
  quoteUnitCode?: string
  /**
   * 备注
   */
  remark?: string
  /**
   * 排序号
   */
  sortOrder?: number
  /**
   * 技术规范编码（冗余）
   */
  techSpecCode?: string
  /**
   * 单价
   */
  unitPrice?: number
  /**
   * 更新时间戳
   */
  updatedAt?: number
  [property: string]: any
}

/**
 * 货期（枚举的中文描述）
 */
export enum DeliveryPeriod {
  The0 = '0',
  The1 = '1',
  The2 = '2',
  The3 = '3',
  The4 = '4',
  The5 = '5',
  The6 = '6',
  The7 = '7',
}

// 供应商获取询价单详情（包含报价单信息）
export const GET_INQUIRY_DETAIL = (inquiryId: string) =>
  GET<SupplierInquiryWithQuotationVO>(`${HTTP}/inquiry/detail/${inquiryId}`)

export interface QuotationItemCountVO {
  quotedItemCount: number
  totalItemCount: number
  unquotedItemCount: number
}

export const GET_QUOTATION_ITEM_COUNT = (
  inquiryId: string,
  supplierId?: string,
) =>
  GET<QuotationItemCountVO>(`${HTTP}/inquiry/detail/${inquiryId}/itemCount`, {
    supplierId: supplierId ?? getSupplierId(),
  })

export const PAGE_QUERY_QUOTATION_ITEMS = (
  inquiryId: string,
  params?: { pageNo?: number; pageSize?: number; supplierId?: string },
) =>
  GET<TableRes<QuotationItemDTO>>(`${HTTP}/inquiry/detail/${inquiryId}/items`, {
    pageNo: params?.pageNo ?? 1,
    pageSize: params?.pageSize ?? 10,
    supplierId: params?.supplierId ?? getSupplierId(),
  })

export interface ConfirmAcceptDTO {
  /**
   * 询价单ID
   */
  inquiryId: string
  /**
   * 供应商ID（可选，不传则使用当前登录供应商）
   */
  supplierId?: string
}

// 供应商确认接单
export const CONFIRM_ACCEPT = (params: ConfirmAcceptDTO) =>
  POST(`${HTTP}/inquiry/confirmAccept`, params, 'application/json')

// 供应商提交报价
export interface SubmitQuotationDTO {
  /**
   * 附件路径（多个用逗号分隔）
   */
  attachment?: string
  /**
   * 邮箱
   */
  contactEmail?: string
  /**
   * 供应商联系人
   */
  contactPerson?: string
  /**
   * 联系电话
   */
  contactPhone?: string
  /**
   * 询价单ID
   */
  inquiryId: string
  /**
   * 报价明细列表
   */
  items?: QuotationItemForm[]
  /**
   * 报价单ID（编辑时使用）
   */
  quotationId?: string
  /**
   * 供应商地址
   */
  supplierAddress?: string
  /**
   * 供应商ID
   */
  supplierId: string
  /**
   * 报价有效期时间戳
   */
  validUntil?: number
  [property: string]: any
}

/**
 * 报价明细表单
 *
 * QuotationItemForm
 */
export interface QuotationItemForm {
  /**
   * 金额
   */
  amount: number
  /**
   * 附件路径（多个用逗号分隔）
   */
  attachment?: string
  /**
   * 配置明细
   */
  configDetail?: string
  /**
   * 货期（枚举的中文描述）
   */
  deliveryPeriod?: DeliveryPeriod
  /**
   * 是否含运费：0-否 1-是
   */
  includeFreight: 0 | 1
  /**
   * 询价明细ID
   */
  inquiryItemId: string
  /**
   * 报价品牌
   */
  quoteProductBrand?: string
  /**
   * 报价产品编码
   */
  quoteProductCode?: string
  /**
   * 报价产品名称
   */
  quoteProductName: string
  /**
   * 报价产品规格型号
   */
  quoteProductSpec?: string
  /**
   * 报价数量
   */
  quoteQty: number
  /**
   * 报价单位
   */
  quoteUnit: string
  /**
   * 报价单位编码
   */
  quoteUnitCode: string
  /**
   * 备注
   */
  remark?: string
  /**
   * 单价
   */
  unitPrice: number
}

// 供应商提交报价
export const SUBMIT_QUOTATION = (params: SubmitQuotationDTO) =>
  POST(`${HTTP}/inquiry/submitQuotation`, params, 'application/json')

export interface SupplierTempSaveQuotationItemForm {
  amount?: number
  attachment?: string
  configDetail?: string
  deliveryPeriod?: string
  includeFreight?: number
  inquiryItemId: string
  marketPrice?: number
  paramDifference?: string
  quoteProductBrand?: string
  quoteProductCode?: string
  quoteProductName?: string
  quoteProductSpec?: string
  quoteQty?: number
  quoteUnit?: string
  quoteUnitCode?: string
  remark?: string
  unitPrice?: number
}

export interface SupplierTempSaveQuotationForm {
  attachment?: string
  contactEmail?: string
  contactPerson?: string
  contactPhone?: string
  inquiryId: string
  items?: SupplierTempSaveQuotationItemForm[]
  quotationId?: string
  supplierAddress?: string
  supplierId: string
  validUntil?: number
}

export const TEMP_SAVE_QUOTATION = (params: SupplierTempSaveQuotationForm) =>
  POST(`${HTTP}/inquiry/tempSaveQuotation`, params, 'application/json')

export interface InquiryQuotationExportQuery {
  inquiryItemIds: string[]
  supplierId?: string
  userId?: string
  // 前端字段
  multiple: boolean
}

/**
 * 导出询价单
 * @param params
 * @returns
 */
export const EXPORT_INQUIRY = (params: InquiryQuotationExportQuery) => {
  const exportLength = params?.inquiryItemIds?.length ?? 0
  const finalParams = {
    ...omit(params, ['multiple']),
    supplierId: params.supplierId ?? getSupplierId(),
    userId: params.userId ?? getUserId(),
  }
  if (params.multiple) {
    return request.POST(
      `${HTTP}/inquiry/export`,
      finalParams,
      'application/json',
    )
  } else {
    return request.downFilePost(`${HTTP}/inquiry/export`, finalParams)
  }
}

/**
 * 导出询价单详情页
 * @param params
 * @returns
 */
export const EXPORT_INQUIRY_DETAIL_PAGE = (params: {
  inquiryId: string
  supplierId?: string
}) =>
  request.downFileGET(`${HTTP}/inquiry/export/${params.inquiryId}`, {
    supplierId: params.supplierId ?? getSupplierId(),
  })

export const IMPORT_INQUIRY = (file: File | Blob, supplierId?: string) =>
  request.uploadFilePOST(`${HTTP}/inquiry/import`, file, {
    supplierId: supplierId ?? getSupplierId(),
  })

export const IMPORT_INQUIRY_DETAIL_PAGE = (
  file: File | Blob,
  params: { inquiryId: string; supplierId?: string },
) =>
  request.uploadFilePOST(`${HTTP}/inquiry/import/${params.inquiryId}`, file, {
    supplierId: params.supplierId ?? getSupplierId(),
  })

export interface BatchQuotationItemDetail {
  amount?: number
  attachment?: string
  configDetail?: string
  deliveryPeriod?: string
  includeFreight?: number
  inquiryItemId: string
  marketPrice?: number
  paramDifference?: string
  quoteProductBrand?: string
  quoteProductCode?: string
  quoteProductName?: string
  quoteProductSpec?: string
  quoteQty?: number
  quoteUnit?: string
  quoteUnitCode?: string
  remark?: string
  unitPrice?: number
}

export interface SubmitBatchQuotationItemsDTO {
  inquiryId: string
  supplierId: string
  items: BatchQuotationItemDetail[]
}

export const SUBMIT_BATCH_QUOTATION_ITEMS = (
  params: SubmitBatchQuotationItemsDTO,
) =>
  POST(`${HTTP}/inquiry/submitBatchQuotationItems`, params, 'application/json')

export interface GiveUpQuotationItemDTO {
  /** 询价单ID */
  inquiryId: string
  /** 询价明细ID */
  inquiryItemId: string
  /** 供应商ID */
  supplierId?: string
}

/** 自动提交结果 */
export interface AutoSubmitResult {
  /** 是否触发了自动提交 */
  autoSubmitted: boolean
  /** 自动提交后的SCP询价单状态 */
  scpOrderStatus?: string | null
  /** 描述信息 */
  message?: string | null
  /** 自动提交失败时的错误原因 */
  errorMessage?: string | null
}

// 供应商放弃报价（单条明细）
export const GIVE_UP_QUOTATION_ITEM = (params: GiveUpQuotationItemDTO) =>
  POST<AutoSubmitResult>(
    `${HTTP}/inquiry/abandonItem`,
    params,
    'application/json',
  )
import request from '@/tools/request'
import { HTTP } from './http'
import { TableRes } from '@/global'
import { getSupplierId, getUserId } from '@/tools'
import { omit } from 'lodash'
const { GET, POST } = request

export interface InquiryOrderQueryDTO {
  /**
   * 完结状态：1-未完结，2-已完结，3-全部
   */
  completionStatus?: number
  /**
   * 询价截止日期-结束
   */
  endExpireDate?: number
  /**
   * 询价公司名称
   */
  groupName?: string
  /**
   * 询价单号
   */
  inquiryNo?: string
  /**
   * 是否已到期
   */
  isExpired?: boolean
  /**
   * 是否即将到期（3天内）
   */
  isExpiringSoon?: boolean
  /**
   * 是否急单
   */
  isUrgent?: boolean
  /**
   * 物料条数
   */
  materialCount?: number
  /**
   * 物料条数操作符
   * 0 :EQUALS
   * 1 :LESS
   * 2 :GREATER
   * 3 :NO_EQUALS
   */
  materialCountOperator?: MaterialCountOperator
  /**
   * 当前页
   */
  pageNo?: number
  /**
   * 每页展示数量
   */
  pageSize?: number
  /**
   * 采购员姓名
   */
  purchaserName?: string
  /**
   * 搜索方案ID
   */
  schemeId?: string
  /**
   * 询价截止日期-开始
   */
  startExpireDate?: number
  /**
   * 状态（供应商响应状态）
   * 0 :待接单：供应商在SCP接单
   * 1 :待报价：供应商在SCP对待接单的询价单直接报价
   * 2 :已报价：供应商在SCP对待报价的询价单进行报价
   * 3 :待重新报价：采购在SRM重新报价，供应商在SCP重新报价
   * 4 :采购方取消：采购在SRM放弃询价或采购在SRM选用了其他报价
   */
  status?: Status
  /**
   * 供应商ID
   */
  supplierId: string
  /**
   * 用户ID
   */
  userId: string
  [property: string]: any
}

/**
 * 物料条数操作符
 * 0 :EQUALS
 * 1 :LESS
 * 2 :GREATER
 * 3 :NO_EQUALS
 */
export enum MaterialCountOperator {
  The0 = '0',
  The1 = '1',
  The2 = '2',
  The3 = '3',
}

/**
 * 状态（供应商响应状态）
 * 0 :待接单：供应商在SCP接单
 * 1 :待报价：供应商在SCP对待接单的询价单直接报价
 * 2 :已报价：供应商在SCP对待报价的询价单进行报价
 * 3 :待重新报价：采购在SRM重新报价，供应商在SCP重新报价
 * 4 :采购方取消：采购在SRM放弃询价或采购在SRM选用了其他报价
 */
export enum Status {
  The0 = '0',
  The1 = '1',
  The2 = '2',
  The3 = '3',
  The4 = '4',
}

export interface InquiryOrderDTO {
  /**
   * 创建时间
   */
  createdAt?: number
  /**
   * 询价截止日期
   */
  expireDate?: number
  /**
   * 询价公司名称
   */
  groupName?: string
  /**
   * 询价单ID
   */
  inquiryId?: string
  /**
   * 询价单号
   */
  inquiryNo?: string
  /**
   * 物料条数
   */
  materialCount?: number
  /**
   * 采购员姓名
   */
  purchaserName?: string
  /**
   * 供应商响应状态
   */
  status?: string
  /**
   * 供应商响应状态文案
   */
  statusText?: string
  /**
   * 标签列表
   */
  tags?: string[]
  /**
   * 是否急单：0-否 1-是
   */
  urgent?: 0 | 1
}

export interface InquiryOrderItemDTO {
  /**
   * 询价单创建时间戳
   */
  createdAt?: number
  /**
   * 询价截止日期时间戳
   */
  expireDate?: number
  /**
   * 询价公司名称
   */
  groupName?: string
  /**
   * 询价单ID
   */
  inquiryId?: string
  /**
   * 询价明细ID（行ID）
   */
  inquiryItemId?: string
  /**
   * 询价单号
   */
  inquiryNo?: string
  /**
   * 物料条数（询价单包含的物料项数）
   */
  materialCount?: number
  /**
   * 采购员姓名
   */
  purchaserName?: string
  /**
   * 供应商响应状态（编码）
   */
  status?: string
  /**
   * 供应商响应状态文案
   */
  statusText?: string
  /**
   * 标签列表（如 急单 等）
   */
  tags?: string[]
  /**
   * 是否急单：0-否 1-是
   */
  urgent?: 0 | 1
  /**
   * 附件路径（多个用逗号分隔）
   */
  attachment?: string
  /**
   * 前端分组标记：同一询价单号首行标识
   */
  __isFirstOfInquiry?: boolean
  /**
   * 序号（行排序号）
   */
  sortOrder?: number
  /**
   * 明细状态（编码）
   */
  itemStatus?: string
  /**
   * 明细状态文案
   */
  itemStatusText?: string
  /**
   * 来源唯一标识码
   */
  inquiryTaskNo?: string
  /**
   * 客方物料名称
   */
  clientMaterialName?: string
  /**
   * 客方需求数量
   */
  clientMaterialQty?: number
}

// 供应商询价单列表分页查询
export const GET_INQUIRY_LIST = (params: InquiryOrderQueryDTO) =>
  GET<TableRes<InquiryOrderDTO>>(`${HTTP}/inquiry/list`, {
    ...params,
    supplierId: getSupplierId(),
  })

export const GET_INQUIRY_LIST_ITEMS = (params: InquiryOrderQueryDTO) =>
  GET<TableRes<InquiryOrderItemDTO>>(`${HTTP}/inquiry/list/items`, {
    ...params,
    supplierId: getSupplierId(),
  })

/**
 * 结果数据
 *
 * InquiryTabCountVO
 */
export interface InquiryTabCountVO {
  /**
   * 已完结数量
   */
  finishedCount: number
  /**
   * 全部数量
   */
  totalCount: number
  /**
   * 未完结数量
   */
  unfinishedCount: number
}
// 供应商询价单TAB数量统计
export const GET_INQUIRY_TABCOUNTS = (params: InquiryOrderQueryDTO) =>
  GET<InquiryTabCountVO>(`${HTTP}/inquiry/tabCounts`, {
    ...params,
    supplierId: getSupplierId(),
  })

export interface SupplierInquiryWithQuotationVO {
  /**
   * 接单时间戳
   */
  acceptTime?: number
  /**
   * 四级类目编码
   */
  categoryLevel4Code?: string
  /**
   * 四级类目名称
   */
  categoryLevel4Name?: string
  /**
   * 邮箱
   */
  contactEmail?: string
  /**
   * 供应商联系人
   */
  contactPerson?: string
  /**
   * 联系电话
   */
  contactPhone?: string
  /**
   * 采购部门编码
   */
  departmentCode?: string
  /**
   * 采购部门名称
   */
  departmentName?: string
  /**
   * 询价截止日期时间戳
   */
  expireDate?: number
  /**
   * 组织编码
   */
  groupCode?: string
  /**
   * 是否已报价
   */
  hasQuoted?: boolean
  /**
   * 询价单附件路径
   */
  inquiryAttachment?: string
  /**
   * 询价单创建时间戳
   */
  inquiryCreatedAt?: number
  /**
   * 询价单创建人姓名
   */
  inquiryCreatorName?: string
  /**
   * 询价单ID
   */
  inquiryId?: string
  /**
   * 询价单号
   */
  inquiryNo?: string
  /**
   * 供应商响应状态（来自InquiryAllowedSupplier表）
   * 供应商响应状态
   */
  inquiryStatus?: InquiryStatus
  /**
   * 供应商响应状态文案
   */
  inquiryStatusText?: string
  /**
   * 询价单标签列表
   */
  inquiryTags?: string[]
  /**
   * 询价类型
   */
  inquiryType?: InquiryType
  /**
   * 询价类型文案
   */
  inquiryTypeText?: string
  /**
   * 报价明细列表（包含询价单明细信息和对应的报价信息）
   * 对于未报价的明细，只包含询价信息，报价相关字段为空
   * 报价明细列表（包含询价单明细和报价信息）
   */
  items: QuotationItemDTO[]
  /**
   * 上次催办时间时间戳
   */
  lastReminderTime?: number
  /**
   * 采购员工号编码
   */
  purchaserCode?: string
  /**
   * 采购员姓名
   */
  purchaserName?: string
  /**
   * 报价单附件路径
   */
  quotationAttachment?: string
  /**
   * 报价单创建时间戳
   */
  quotationCreatedAt?: number
  /**
   * 报价单创建人姓名
   */
  quotationCreatorName?: string
  /**
   * 报价单ID
   */
  quotationId?: string
  /**
   * 报价单号
   */
  quotationNo?: string
  /**
   * 报价单标签列表
   */
  quotationTags?: string[]
  /**
   * 驳回原因
   */
  rejectReason?: string
  /**
   * 备注说明
   */
  remark?: string
  /**
   * 提交时间戳
   */
  submitTime?: number
  /**
   * 供应商地址
   */
  supplierAddress?: string
  /**
   * 供应商ID
   */
  supplierId?: string
  /**
   * 供应商名称
   */
  supplierName?: string
  /**
   * 合计金额
   */
  totalAmount?: number
  /**
   * 是否急单：0-否 1-是
   */
  urgent?: number
  /**
   * 报价有效期时间戳
   */
  validUntil?: number
  lastTempSaveTime?: number
}

/**
 * 供应商响应状态（来自InquiryAllowedSupplier表）
 * 供应商响应状态
 */
export enum InquiryStatus {
  The0 = '0',
  The1 = '1',
  The2 = '2',
  The3 = '3',
  The4 = '4',
}

/**
 * 询价类型
 */
export enum InquiryType {
  The0 = '0',
  The1 = '1',
}

/**
 * 报价单明细DTO
 *
 * QuotationItemDTO
 */
export interface QuotationItemDTO {
  /**
   * 金额
   */
  amount?: number
  /**
   * 产品明细附件路径（多个用逗号分隔）
   */
  attachment?: string
  /**
   * 客方物资品牌（冗余）
   */
  clientMaterialBrand?: string
  /**
   * 客方物资描述（冗余）
   */
  clientMaterialDesc?: string
  /**
   * 客方物资名称（冗余）
   */
  clientMaterialName?: string
  /**
   * 客方需求数量（冗余）
   */
  clientMaterialQty?: number
  /**
   * 客方物资规格（冗余）
   */
  clientMaterialSpec?: string
  /**
   * 客方物资单位（冗余）
   */
  clientMaterialUnit?: string
  /**
   * 客方备注
   */
  clientRemark?: string
  /**
   * 配置明细
   */
  configDetail?: string
  /**
   * 创建时间戳
   */
  createdAt?: number
  /**
   * 交货地点（冗余）
   */
  deliveryAddress?: string
  /**
   * 货期（枚举的中文描述）
   */
  deliveryPeriod?: string
  /**
   * 主键
   */
  id?: string
  /**
   * 是否含运费：0-否 1-是
   */
  includeFreight?: number
  /**
   * 对应的询价明细ID
   */
  inquiryItemId?: string
  /**
   * 询价任务编号（冗余）
   */
  inquiryTaskNo?: string
  /**
   * 报价明细状态：DRAFT-暂存，QUOTED-已报价
   */
  itemStatus?: string
  /**
   * 产品市场价
   */
  marketPrice?: number
  /**
   * 参数差异点
   */
  paramDifference?: string
  /**
   * 产品限价（单价）
   */
  priceLimit?: number
  /**
   * 报价单ID
   */
  quotationId?: string
  /**
   * 报价要求（冗余）
   */
  quotationRequirement?: string
  /**
   * 报价品牌
   */
  quoteProductBrand?: string
  /**
   * 报价产品编码
   */
  quoteProductCode?: string
  /**
   * 报价产品名称
   */
  quoteProductName?: string
  /**
   * 报价产品规格型号
   */
  quoteProductSpec?: string
  /**
   * 报价数量
   */
  quoteQty?: number
  /**
   * 报价单位
   */
  quoteUnit?: string
  /**
   * 报价单位编码
   */
  quoteUnitCode?: string
  /**
   * 备注
   */
  remark?: string
  /**
   * 排序号
   */
  sortOrder?: number
  /**
   * 技术规范编码（冗余）
   */
  techSpecCode?: string
  /**
   * 单价
   */
  unitPrice?: number
  /**
   * 更新时间戳
   */
  updatedAt?: number
  [property: string]: any
}

/**
 * 货期（枚举的中文描述）
 */
export enum DeliveryPeriod {
  The0 = '0',
  The1 = '1',
  The2 = '2',
  The3 = '3',
  The4 = '4',
  The5 = '5',
  The6 = '6',
  The7 = '7',
}

// 供应商获取询价单详情（包含报价单信息）
export const GET_INQUIRY_DETAIL = (inquiryId: string) =>
  GET<SupplierInquiryWithQuotationVO>(`${HTTP}/inquiry/detail/${inquiryId}`)

export interface QuotationItemCountVO {
  quotedItemCount: number
  totalItemCount: number
  unquotedItemCount: number
}

export const GET_QUOTATION_ITEM_COUNT = (
  inquiryId: string,
  supplierId?: string,
) =>
  GET<QuotationItemCountVO>(`${HTTP}/inquiry/detail/${inquiryId}/itemCount`, {
    supplierId: supplierId ?? getSupplierId(),
  })

export const PAGE_QUERY_QUOTATION_ITEMS = (
  inquiryId: string,
  params?: { pageNo?: number; pageSize?: number; supplierId?: string },
) =>
  GET<TableRes<QuotationItemDTO>>(`${HTTP}/inquiry/detail/${inquiryId}/items`, {
    pageNo: params?.pageNo ?? 1,
    pageSize: params?.pageSize ?? 10,
    supplierId: params?.supplierId ?? getSupplierId(),
  })

export interface ConfirmAcceptDTO {
  /**
   * 询价单ID
   */
  inquiryId: string
  /**
   * 供应商ID（可选，不传则使用当前登录供应商）
   */
  supplierId?: string
}

// 供应商确认接单
export const CONFIRM_ACCEPT = (params: ConfirmAcceptDTO) =>
  POST(`${HTTP}/inquiry/confirmAccept`, params, 'application/json')

// 供应商提交报价
export interface SubmitQuotationDTO {
  /**
   * 附件路径（多个用逗号分隔）
   */
  attachment?: string
  /**
   * 邮箱
   */
  contactEmail?: string
  /**
   * 供应商联系人
   */
  contactPerson?: string
  /**
   * 联系电话
   */
  contactPhone?: string
  /**
   * 询价单ID
   */
  inquiryId: string
  /**
   * 报价明细列表
   */
  items?: QuotationItemForm[]
  /**
   * 报价单ID（编辑时使用）
   */
  quotationId?: string
  /**
   * 供应商地址
   */
  supplierAddress?: string
  /**
   * 供应商ID
   */
  supplierId: string
  /**
   * 报价有效期时间戳
   */
  validUntil?: number
  [property: string]: any
}

/**
 * 报价明细表单
 *
 * QuotationItemForm
 */
export interface QuotationItemForm {
  /**
   * 金额
   */
  amount: number
  /**
   * 附件路径（多个用逗号分隔）
   */
  attachment?: string
  /**
   * 配置明细
   */
  configDetail?: string
  /**
   * 货期（枚举的中文描述）
   */
  deliveryPeriod?: DeliveryPeriod
  /**
   * 是否含运费：0-否 1-是
   */
  includeFreight: 0 | 1
  /**
   * 询价明细ID
   */
  inquiryItemId: string
  /**
   * 报价品牌
   */
  quoteProductBrand?: string
  /**
   * 报价产品编码
   */
  quoteProductCode?: string
  /**
   * 报价产品名称
   */
  quoteProductName: string
  /**
   * 报价产品规格型号
   */
  quoteProductSpec?: string
  /**
   * 报价数量
   */
  quoteQty: number
  /**
   * 报价单位
   */
  quoteUnit: string
  /**
   * 报价单位编码
   */
  quoteUnitCode: string
  /**
   * 备注
   */
  remark?: string
  /**
   * 单价
   */
  unitPrice: number
}

// 供应商提交报价
export const SUBMIT_QUOTATION = (params: SubmitQuotationDTO) =>
  POST(`${HTTP}/inquiry/submitQuotation`, params, 'application/json')

export interface SupplierTempSaveQuotationItemForm {
  amount?: number
  attachment?: string
  configDetail?: string
  deliveryPeriod?: string
  includeFreight?: number
  inquiryItemId: string
  marketPrice?: number
  paramDifference?: string
  quoteProductBrand?: string
  quoteProductCode?: string
  quoteProductName?: string
  quoteProductSpec?: string
  quoteQty?: number
  quoteUnit?: string
  quoteUnitCode?: string
  remark?: string
  unitPrice?: number
}

export interface SupplierTempSaveQuotationForm {
  attachment?: string
  contactEmail?: string
  contactPerson?: string
  contactPhone?: string
  inquiryId: string
  items?: SupplierTempSaveQuotationItemForm[]
  quotationId?: string
  supplierAddress?: string
  supplierId: string
  validUntil?: number
}

export const TEMP_SAVE_QUOTATION = (params: SupplierTempSaveQuotationForm) =>
  POST(`${HTTP}/inquiry/tempSaveQuotation`, params, 'application/json')

export interface InquiryQuotationExportQuery {
  inquiryItemIds: string[]
  supplierId?: string
  userId?: string
  // 前端字段
  multiple: boolean
}

/**
 * 导出询价单
 * @param params
 * @returns
 */
export const EXPORT_INQUIRY = (params: InquiryQuotationExportQuery) => {
  const exportLength = params?.inquiryItemIds?.length ?? 0
  const finalParams = {
    ...omit(params, ['multiple']),
    supplierId: params.supplierId ?? getSupplierId(),
    userId: params.userId ?? getUserId(),
  }
  if (params.multiple) {
    return request.POST(
      `${HTTP}/inquiry/export`,
      finalParams,
      'application/json',
    )
  } else {
    return request.downFilePost(`${HTTP}/inquiry/export`, finalParams)
  }
}

/**
 * 导出询价单详情页
 * @param params
 * @returns
 */
export const EXPORT_INQUIRY_DETAIL_PAGE = (params: {
  inquiryId: string
  supplierId?: string
}) =>
  request.downFileGET(`${HTTP}/inquiry/export/${params.inquiryId}`, {
    supplierId: params.supplierId ?? getSupplierId(),
  })

export const IMPORT_INQUIRY = (file: File | Blob, supplierId?: string) =>
  request.uploadFilePOST(`${HTTP}/inquiry/import`, file, {
    supplierId: supplierId ?? getSupplierId(),
  })

export const IMPORT_INQUIRY_DETAIL_PAGE = (
  file: File | Blob,
  params: { inquiryId: string; supplierId?: string },
) =>
  request.uploadFilePOST(`${HTTP}/inquiry/import/${params.inquiryId}`, file, {
    supplierId: params.supplierId ?? getSupplierId(),
  })

export interface BatchQuotationItemDetail {
  amount?: number
  attachment?: string
  configDetail?: string
  deliveryPeriod?: string
  includeFreight?: number
  inquiryItemId: string
  marketPrice?: number
  paramDifference?: string
  quoteProductBrand?: string
  quoteProductCode?: string
  quoteProductName?: string
  quoteProductSpec?: string
  quoteQty?: number
  quoteUnit?: string
  quoteUnitCode?: string
  remark?: string
  unitPrice?: number
}

export interface SubmitBatchQuotationItemsDTO {
  inquiryId: string
  supplierId: string
  items: BatchQuotationItemDetail[]
}

export const SUBMIT_BATCH_QUOTATION_ITEMS = (
  params: SubmitBatchQuotationItemsDTO,
) =>
  POST(`${HTTP}/inquiry/submitBatchQuotationItems`, params, 'application/json')

export interface GiveUpQuotationItemDTO {
  /** 询价单ID */
  inquiryId: string
  /** 询价明细ID */
  inquiryItemId: string
  /** 供应商ID */
  supplierId?: string
}

/** 自动提交结果 */
export interface AutoSubmitResult {
  /** 是否触发了自动提交 */
  autoSubmitted: boolean
  /** 自动提交后的SCP询价单状态 */
  scpOrderStatus?: string | null
  /** 描述信息 */
  message?: string | null
  /** 自动提交失败时的错误原因 */
  errorMessage?: string | null
}

// 供应商放弃报价（单条明细）
export const GIVE_UP_QUOTATION_ITEM = (params: GiveUpQuotationItemDTO) =>
  POST<AutoSubmitResult>(
    `${HTTP}/inquiry/abandonItem`,
    params,
    'application/json',
  )
